import React, { useState } from "react";
import { Field } from "redux-form";
import { isArray } from "lodash";
import { required } from "redux-form-validators";

import { Button } from "../../components/Field/";
import { getIcon } from "../../helpers/icons";
import { showToast } from "../../helpers/notify";
import { downloadTxtFile } from "../../helpers/media";
import Spinner from "../Spinner";
import Link from "../../components/Link";
import Title from "../../components/Title";
import Spacer from "../../components/Spacer";
import Editor from "../../components/Editor";
import AsyncGet from "../../components/AsyncGet";
import Textarea from "../../components/Field/Input/Textarea";
import AsyncForm from "../../components/AsyncForm";

import style from "./style.module.css";

export default function Feedback({ id, name = "", transcript = "", download = 0, type = "", closeDialog = "" }) {

    const [step, setStep] = useState(null);
    const [reportType, setReportType] = useState(null);
    const [reportTypeLastValue, setReportTypeLastValue] = useState(null);

    let title = "How can we help you";
    if (step === "feedback") {
        title = "FEEDBACK";
    } else if (step === "issue") {
        title = "REPORT AN ISSUE";
    }

    if (type === "feedback") {
        return (
            <div className={` ${style.feedback} ${style.popupArea}`}>
                <div className={style.popupWrap}>
                    <div className={style.sectionHeader}>
                        {
                            step === null && (
                                <Link 
                                    className={`${style.dialogClose}`}
                                    onClick={closeDialog}
                                >
                                    <i className={getIcon("Arrow-left")}></i>
                                </Link>
                            )
                        }
                        {
                            step === "feedback" && (
                                <Link 
                                    onClick={() => { setStep(null) }}
                                    className={`${style.dialogClose}`}
                                >
                                    <i className={getIcon("Arrow-left")}></i>
                                </Link>
                            )
                        }
                        {
                            (step === "issue" && reportType === null) && (
                                <Link 
                                    onClick={() => { setStep(null); setReportTypeLastValue(null); }}
                                    className={`${style.dialogClose}`}
                                >
                                    <i className={getIcon("Arrow-left")}></i>
                                </Link>
                            )
                        }
                        {
                            (step === "issue" && reportType !== null) && (
                                <Link 
                                    onClick={() => { setReportType(null) }} 
                                    className={`${style.dialogClose}`}
                                >
                                    <i className={getIcon("Arrow-left")}></i>
                                </Link>
                            )
                        }
                        <Title className="fontTeko" transform="uppercase" tag="h2">{title}</Title>
                    </div>
                    {
                        step === null && (
                            <div className={style.sectionBody}>
                                <div className={style.buttonRow}>
                                    <Button 
                                        onClick={() => { setStep("feedback") }} 
                                        color="buttonPrimary" 
                                        label="LEAVE FEEDBACK" 
                                    />
                                    <Button 
                                        onClick={() => { setStep("issue") }} 
                                        color="buttonPrimaryWithOutBg" 
                                        label="REPORT AN ISSUE" 
                                    />
                                    <Button 
                                        link="/contact-us"
                                        color="buttonPrimaryWithOutBg" 
                                        label="GENERAL CONTACT" 
                                    />
                                </div>
                            </div>
                        )
                    }
                    {
                        step === "feedback" && (
                            <div className={`${style.sectionFooter} ${style.sectionFooter} ${style.msgBoxSection}`}>
                                <AsyncForm
                                    url={`/account/feedback/${id}`}
                                    permissionText="Feedback"
                                    showToastOnSuccess={false}
                                    hasGetAction={false}
                                    onSave={() => {
                                        closeDialog();
                                        showToast("Your feedback submitted");
                                    }}
                                    paramsData={{
                                        model_for: "article"
                                    }}
                                    render={({ fetching }) => {
                                        return (
                                            <>
                                                <Title tag="p">Add your feedback below</Title>
                                                <Spacer size="16" />
                                                <Field 
                                                    placeholder="Leave your message here." 
                                                    name="message" 
                                                    component={Textarea} 
                                                    validate={required()} 
                                                    type="textarea" 
                                                />
                                                <Spacer size="24" />
                                                <Button
                                                    color="buttonPrimary"
                                                    submit={true}
                                                    fetching={fetching}
                                                    label="Submit"
                                                />
                                            </>
                                        )
                                    }}
                                />
                            </div>
                        )
                    }
                    {
                        step === "issue" && (
                            <div className={`${style.sectionFooter} ${style.sectionFooter} ${style.msgBoxSection}`}>
                                {
                                    reportType === null && (
                                        <AsyncGet
                                            url="list/report-type"
                                            permissionText="Report"
                                            loadOnMount={true}
                                            paramsData={{
                                                "used_for" : "article"
                                            }}
                                            render={({ data, fetching }) => {
                                                if (fetching === true) {
                                                    return (
                                                        <div className={style.spinner}>
                                                            <Spinner />
                                                        </div>
                                                    )
                                                }
                                                else if (fetching === false && isArray(data.list)) {
                                                    return (
                                                        data.list.map((item, index) => {
                                                            return (
                                                                <div key={`report_type_item_${index}`} className={style.reportType}>
                                                                    <div 
                                                                        onClick={() => { setReportType(item.id); setReportTypeLastValue(item.title) }} 
                                                                        className={`${style.reportTypeItem} ${reportTypeLastValue === item.title ? style.active : ""}`}
                                                                    >
                                                                        <Title transform="uppercase" className="fontTeko" tag="h6">{item.title}</Title>
                                                                        <Title tag="p">{item.desc}</Title>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    )
                                                }
                                            }}
                                        />
                                    )
                                }
                                {
                                    reportType !== null && (
                                        <AsyncForm
                                            url={`/account/report/${id}`}
                                            permissionText="Report"
                                            showToastOnSuccess={false}
                                            hasGetAction={false}
                                            onSave={() => {
                                                closeDialog();
                                                showToast("Your report submitted");
                                            }}
                                            paramsData={{
                                                model_for: "article",
                                                report_type_id: reportType,
                                            }}
                                            render={({ fetching }) => {
                                                return (
                                                    <>
                                                        <Title tag="p">Add your feedback below</Title>
                                                        <Spacer size="16" />
                                                        <Field 
                                                            name="message" 
                                                            placeholder="Leave your message here." 
                                                            component={Textarea} 
                                                            validate={required()} 
                                                            type="textarea" 
                                                        />
                                                        <Spacer size="24" />
                                                        <Button
                                                            color="buttonPrimary"
                                                            submit={true}
                                                            fetching={fetching}
                                                            label="Submit"
                                                        />
                                                    </>
                                                )
                                            }}
                                        />
                                    )
                                }
                            </div>
                        )
                    }
                </div>
            </div>
        )
    } else {
        return (
            <div className={style.popupArea}>
                <div className={style.popupWrap}>
                    <div className={style.sectionHeader}>
                        <Title className="fontTeko" transform="uppercase" tag="h2">Transcript</Title>
                    </div>
                    {
                        transcript !== "" && (
                            <div className={style.sectionBody}>
                                <Editor text={transcript} />
                            </div>
                        )
                    }
                    {
                        download === 1 && (
                            <div className={style.sectionFooter}>
                                <Link 
                                    onClick={() => { downloadTxtFile(name, transcript) }} 
                                    download={false}
                                >
                                    <i className={getIcon("Download")}></i> 
                                    Download
                                </Link>
                            </div>
                        )
                    }
                </div>
            </div>
        )
    }
}